import { NeedsTransportQuestionActions } from "../action/needsTransportQuestion-action";

export type NeedsTransportResponse = "Yes" | "No";

type NeedsTransportState = {
  customerResponse: NeedsTransportResponse;
};

const initialState: NeedsTransportState = {
  customerResponse: undefined,
};

export const NeedsTransportReducer = (
  state: NeedsTransportState = initialState,
  action: NeedsTransportQuestionActions
): NeedsTransportState => {
  switch (action.type) {
    case "UPDATE_NEEDS_TRANSPORT_QUESTIONS":
      return { ...state, customerResponse: action.payload };
    case "REFRESH_REDUCERS":
    case "CLEAR_NEEDS_TRANSPORT_QUESTIONS":
      return { ...initialState };
    default:
      return state;
  }
};
